import { createAsyncTypes } from 'utils/ActionCreator'

export const SHARE_SUBMIT_ASYNC = createAsyncTypes('SHARE_SUBMIT', 'ShareReport')
export const FETCH_SHARING_EMAILS_ASYNC = createAsyncTypes(
  'FETCH_SHARING_EMAILS_ASYNC',
  'ShareReport'
)

export const SHARE_RESET = 'ShareReport/SHARE_RESET'
export const SHARE_RESET_ERROR = 'ShareReport/SHARE_RESET_ERROR'
export const FILE_TYPE_CHANGE = 'ShareReport/FILE_TYPE_CHANGE'
export const SHARE_EMAILS_CHANGE = 'ShareReport/SHARE_EMAILS_CHANGE'
export const SHARE_MESSAGE_CHANGE = 'ShareReport/SHARE_MESSAGE_CHANGE'

export const CSV_OPTION_CONST = 1
export const PDF_OPTION_CONST = 2
export const HTML_OPTION_CONST = 3

export const FILE_OPTIONS_CONST = [
  { value: CSV_OPTION_CONST, label: 'CSV', id: 'csv' },
  { value: PDF_OPTION_CONST, label: 'PDF', id: 'pdf' },
  { value: HTML_OPTION_CONST, label: 'HTML', id: 'html' },
]

export const SHARE_TYPE = {
  REPORT: {
    AWARENESS: 'report_awareness',
    PHISHING_SIMULATOR: 'report_phishingSimulator',
    THREAT_PROTECTION: 'report_threatProtection',
    SCANBACK: 'report_scanback',
    REPORTED_INCIDENTS: 'report_reportedIncidents',
    ANOMALIES: 'report_anomaliesList',
    INCIDENT_SUMMARY_INCIDENTS: 'report_incidentSummaryIncidents',
    REMEDIATED_EMAILS: 'report_remediatedEmails',
    REPORT_MAILBOXES: 'report_mailboxes',
    THREAT_LOG_REPORT: 'report_threat_log',
    INVESTIGATION_REPORT: 'report_investigation',
    POC_REPORT_LAST_LOG: 'report_poc_last_log',
  },
  TEST: {
    CAMPAIGN: 'test_campaign',
  },
}
